import React from 'react'
import { CustomTextArea, InputFieldContainer, InputLabel } from './TextArea.style';
import PropTypes from 'prop-types';
import FormError  from '../FormError/FormError';

export default function TextArea({ isError, errorMessage, label, required, ...rest }) {
  return (
    <InputFieldContainer>
      <InputLabel htmlFor={rest.name}>
        {label}
        {required && <span className="required">*</span>}
      </InputLabel>
      <CustomTextArea {...rest} $isError={isError} />
      {isError && <FormError message={errorMessage} />}
    </InputFieldContainer>
  );
}


TextArea.propTypes = {
  /**
   * To hide and show the error message
   */
  isError: PropTypes.bool,

  /**
   * Display error message when it is enabled
   */
  errorMessage: PropTypes.string,
  /**
   * Input label
   */
  label: PropTypes.string.isRequired,
  /**
   * Whether the field is required
   */
  required: PropTypes.bool,
};

TextArea.defaultProps = {
  isError: false,
  errorMessage: '',
  label: 'Input Label',
  required: false,
};